import { useEffect } from "react";
import { ArrowLeft, FileText } from "lucide-react";
import { SITE } from "../../content";
import { Eyebrow } from "./Primitives";
import { Seo } from "./Seo";
import { LegalBody } from "./LegalBody";
import { DATENSCHUTZ } from "../../legal/datenschutz";
import { IMPRESSUM } from "../../legal/impressum";
import { AGB } from "../../legal/agb";

export const LEGAL_PAGES = [
  { path: "/impressum", title: "Impressum", description: "Impressum der Schwimmschule Manta, Inhaberin Melissa Siebenlist – Angaben zum Anbieter, Kontakt und Verantwortlichkeit für die Inhalte der Website.", body: IMPRESSUM },
  { path: "/datenschutzerklrung", title: "Datenschutzerklärung", description: "Datenschutzerklärung der Schwimmschule Manta: welche Daten wir bei Website, Kursbuchung über YOLAWO und Eltern-App verarbeiten und welche Rechte Sie haben.", body: DATENSCHUTZ },
  { path: "/agb", title: "AGB", description: "Allgemeine Geschäftsbedingungen der Schwimmschule Manta für alle Schwimmkurse: Anmeldung, Kursgebühren, Fehlzeiten, Aufsichtspflicht und Haftung.", body: AGB },
];

export const LegalPage = ({ page }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <main id="main" data-testid={`legal-page-${page.path.slice(1)}`} className="bg-white">
      <Seo title={`${page.title} | Schwimmschule Manta`} description={page.description} path={page.path} />
      <section className="bg-navy pb-16 pt-36 text-white sm:pb-20 sm:pt-44">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <a href="/" data-testid="legal-back-link" className="group inline-flex items-center gap-2 text-sm font-semibold text-sky-200 hover:text-white">
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" /> Zur Startseite
          </a>
          <Eyebrow dark className="mt-10">Rechtliches</Eyebrow>
          <h1 className="mt-6 text-4xl font-extrabold tracking-[-0.02em] sm:text-5xl lg:text-6xl">{page.title}</h1>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28 lg:px-12">
        <div className="max-w-3xl">
          {page.body ? <LegalBody doc={page.body} /> : (
            <div data-testid="legal-text-pending" className="border border-dashed border-amber-600/50 bg-amber-50 p-8 sm:p-10">
              <FileText className="h-7 w-7 text-amber-800" strokeWidth={1.5} />
              <p className="mt-5 text-xl font-bold text-navy">Text folgt</p>
              <p className="mt-3 text-base leading-relaxed text-slate-700">
                Der Inhalt dieser Seite wird in Kürze ergänzt. Bei Fragen erreichen Sie uns unter{" "}
                <a href={`mailto:${SITE.email}`} className="font-semibold text-navy underline underline-offset-4">{SITE.email}</a>.
              </p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};
